import { Injectable } from '@angular/core';
import { SystemService } from './system.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor(private readonly systemService: SystemService) {}

  /**
   * Gets an value of an item from the local storage
   * @param key of the item
   * @returns the value of the item
   */
  get(key: string): any {
    // Return if server side is detected
    if (!this.systemService.browser) return null;
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  }

  /**
   * Gets all keys from the local storage
   * @returns all keys from the local storage
   */
  keys(): string[] | null {
    // Return if server side is detected
    if (!this.systemService.browser) return null;
    return Object.keys(localStorage);
  }

  /**
   * Sets an item in the local storage
   * @param key of the item
   * @param value of the item
   */
  set(key: string, value: any): void {
    // Return if server side is detected
    if (!this.systemService.browser) return;
    const item = JSON.stringify(value);
    localStorage.setItem(key, item);
  }

  /**
   * Deletes an item from the local storage
   * @param key of the item
   */
  remove(key: string): void {
    // Return if server side is detected
    if (!this.systemService.browser) return;
    localStorage.removeItem(key);
  }
}
